export default "__VITE_ASSET__26994fa2__"